import BlockLength from './BlockLength';

import { Divider, Chip, Typography, Box } from '@mui/material';

const BlockFormat = ({
    xs, setXS, md, setMD, selectedRow, setSelectedRow, rowLength
}) => {
    return (
        <>
            <BlockLength type={'móvil'} selected={xs} setSelected={setXS} />
            <Divider sx={{ m: 2 }} />
            <BlockLength type={'escritorio'} selected={md} setSelected={setMD} />
            <Divider sx={{ m: 2 }} />
            {
                rowLength <= 0 ?
                    <Typography variant="button" gutterBottom sx={{ display: 'block' }}>
                        No hay filas disponibles
                    </Typography>
                :
                <>
                    <Typography variant="subtitle2" gutterBottom>
                        Agregar en fila:
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: '12px', flexWrap: 'wrap' }}>
                        {Array.from({ length: rowLength }, (_, i) => (
                            <Chip
                                key={i}
                                label={`Fila ${i + 1}`}
                                onClick={() => setSelectedRow(i)}
                                sx={{
                                    backgroundColor: i === selectedRow ? '#C8E6C9' : 'transparent',
                                    color: i === selectedRow ? '#1B5E20' : '#000',
                                    fontWeight: i === selectedRow ? 'bold' : 'normal',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        backgroundColor: i === selectedRow ? '#A5D6A7' : '#E5E7E9',
                                    }
                                }}
                            />
                        ))}
                    </Box>
                </>
            }
        </>
    );
};

export default BlockFormat;